const AdminReports = () => {
  return (
    <div>
      AdminReports
    </div>
  )
}

export default AdminReports
